import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { createStyles } from '@mantine/core';
import { addH5StyleMedia } from '../../utils/index.js';
import { RootVariable } from './constant.js';

var _excluded = ["maxWidth", "minWidth"];
var getLgSizeStyles = function getLgSizeStyles() {
  return {
    root: _defineProperty({}, RootVariable.SELECT_HEIGHT, '44px')
  };
};
var useSelectAppTargetStyle = function useSelectAppTargetStyle(_ref) {
  var size = _ref.size;
  return _objectSpread2({}, size === 'lg' ? getLgSizeStyles() : {});
};
var useSelectAppStyle = function useSelectAppStyle(params) {
  var _ref2;
  var withPanel = params.withPanel;
  return {
    dropdown: withPanel ? (_ref2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref2, RootVariable.SELECT_DROPDOWN_PADDING, '8px'), RootVariable.SELECT_ITEM_BASE_PADDING, '12px'), RootVariable.SELECT_ITEM_SELECTED_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_DROPDOWN_RADIUS, '8px 8px 0 0'), RootVariable.SELECT_ITEM_FONT_SIZE, '14px'), RootVariable.SELECT_ITEM_FONT_WEIGHT, 500), RootVariable.SELECT_ITEM_SELECTED_BG, 'var(--gui-color-neutral-2)'), "position", 'fixed'), "minWidth", '100vw'), "minHeight", '40vh'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref2, "maxHeight", '80vh'), "inset", 'auto 0px 0px 0px !important'), "boxShadow", '0 0 0 100vh rgba(0,0,0,.25)'), '& .mantine-ScrollArea-root, & .gui-mantine-rtl-ScrollArea-root', {
      margin: '0 4px'
    }), '& > div:nth-last-of-type(1)', {
      minHeight: '40vh',
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column'
    }), '& > div:nth-last-of-type(1) > div:nth-last-of-type(1)', {
      '@media(max-width: 992px)': {
        maxHeight: 'unset !important',
        flex: 1,
        overflow: 'hidden'
      }
    })) : undefined
  };
};
var createSelectH5Styles = createStyles(function (_, params) {
  var maxWidth = params.maxWidth,
    minWidth = params.minWidth,
    restParams = _objectWithoutProperties(params, _excluded);
  var withDefaultParams = _objectSpread2({
    withPanel: true
  }, restParams);
  return addH5StyleMedia(useSelectAppStyle(withDefaultParams), {
    maxWidth: maxWidth,
    minWidth: minWidth
  });
});

export { createSelectH5Styles, useSelectAppStyle, useSelectAppTargetStyle };
//# sourceMappingURL=GateSelect.app.style.js.map
